import { useNavigate } from "react-router-dom";
import { Video, X } from "lucide-react";
import { useMeetingInvites } from "../hooks/useMeetingInvites";

/**
 * Mounted once in the protected layout: rings when someone starts an instant
 * meeting with you invited.
 */
export function MeetingInvitesHost() {
  const { incoming, dismiss } = useMeetingInvites();
  const navigate = useNavigate();

  if (!incoming) return null;

  return (
    <div className="fixed bottom-20 right-4 z-50 w-80 rounded-xl border border-[var(--color-primary)] bg-[var(--color-bg-surface)] p-4 shadow-2xl">
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[var(--color-primary)] text-white">
          <Video size={16} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-[var(--color-text-primary)]">
            {incoming.from?.name ?? "Ktoś"} zaprasza na spotkanie
          </p>
          <p className="truncate text-xs text-[var(--color-text-secondary)]">
            {incoming.title}
          </p>
          <div className="mt-2 flex gap-2">
            <button
              type="button"
              onClick={() => {
                dismiss();
                navigate(`/meetings/room/${incoming.occurrenceId}`);
              }}
              className="rounded-md bg-[var(--color-primary)] px-3 py-1 text-xs font-medium text-white hover:opacity-90"
            >
              Dołącz
            </button>
            <button
              type="button"
              onClick={dismiss}
              className="rounded-md border border-[var(--color-border)] px-3 py-1 text-xs text-[var(--color-text-secondary)] hover:bg-black/5 dark:hover:bg-white/5"
            >
              Odrzuć
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)]"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
